import { useForm } from '@mantine/form'
import { Button, Flex, LoadingOverlay, Paper, TextInput } from '@mantine/core'
import { Link, useNavigate } from 'react-router-dom'
import { IRequestCreateCoordinator } from '@interfaces/api/ICoordinator'
import Coordinator from '@api/Coordinator'

const FormCreateCoordinator = ({
    aftersuccess,
}: {
    aftersuccess?: () => any
}) => {
    const form = useForm<IRequestCreateCoordinator>({
        initialValues: {
            coordinator_fullname: '',
            coordinator_email: '',
            coordinator_phone: '',
        },
    })
    const navigate = useNavigate()

    const { isLoading, onSubmit } = Coordinator.useCreateCoordinator({
        form,
        aftersuccess: () => navigate('/coordinators'),
    })

    return (
        <Paper pos='relative'>
            <LoadingOverlay visible={isLoading} overlayBlur={2} />
            <form onSubmit={onSubmit}>
                <Flex gap='sm' direction='column'>
                    <TextInput
                        withAsterisk
                        label='ชื่อผู้ประสานงาน'
                        placeholder='ชื่อผู้ประสานงาน'
                        {...form.getInputProps('coordinator_fullname')}
                    />
                    <TextInput
                        label='อีเมล'
                        placeholder='อีเมล'
                        {...form.getInputProps('coordinator_email')}
                    />
                    <TextInput
                        label='เบอร์โทร'
                        placeholder='เบอร์โทร'
                        {...form.getInputProps('coordinator_phone')}
                    />

                    <Flex mt='md' justify='end' gap='sm'>
                        <Button
                            component={Link}
                            to='/coordinators'
                            variant='default'
                            w='fit-content'
                        >
                            ยกเลิก
                        </Button>
                        <Button type='submit' w='fit-content'>
                            สร้างผู้ประสานงาน
                        </Button>
                    </Flex>
                </Flex>
            </form>
        </Paper>
    )
}

export default FormCreateCoordinator
